import {
  Component,
  EventEmitter,
  OnInit,
  OnDestroy,
  Output,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountAdminService } from 'app/back-office/account-admin.service';
import { IdentityService, UserIdentity } from '../../core/identity/identity.service';
import { SiteRoleService } from '../../core/identity/site-role.service';
import DetectedDeviceUtils, { DETECTED_DEVICE } from 'app/shared/utils/detected-device-utils';
import { CurrentContextService } from 'app/core/current-context.service';
import { Subscription } from 'rxjs';
import { TierAccess } from 'app/shared/account/tier.model';
import { MatDialog } from '@angular/material/dialog';
import { BugreportComponent } from 'app/back-office/bugreport/bugreport.component';
import { SettingsService } from 'app/shared/services/admin-settings.service';

@Component({
  selector: 'app-mega-menu',
  templateUrl: './mega-menu.component.html',
  styleUrls: ['./mega-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MegaMenuComponent implements OnInit, OnDestroy {
  @Output() public closeSideMenu = new EventEmitter<any>();
  public currentItem: string;
  public isAdmin: boolean;
  public showSection: true;
  public showMenu: boolean;
  public currentDevice: string;
  public detectedDevice = DETECTED_DEVICE;
  private contextSubscription: Subscription;
  public tierAccess: TierAccess;
  private readonly siteRoleService = inject(SiteRoleService);

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public readonly identityService: IdentityService,
    public readonly accountAdminService: AccountAdminService,
    private readonly currentContextService: CurrentContextService,
    private dialog: MatDialog,
    private settingsService: SettingsService,
  ) {}

  public get isSiteAdmin(): boolean {
    return this.isAdmin || this.siteRoleService.isAccountAdmin();
  }

  ngOnInit(): void {
    this.currentDevice = DetectedDeviceUtils.detectPhone(window.innerWidth);
    this.activatedRoute.data.subscribe((data) => {
      if (data && data.item) {
        this.currentItem = data.item;
      }
    });
    this.init(this.identityService.currentIdentity);
    this.contextSubscription = this.currentContextService.currentContextBS.subscribe((currentContext) => {
      if (currentContext) {
        this.tierAccess = currentContext.tierAccess;
      }
    });
  }
  private init(identity: UserIdentity): void {
    if (identity) {
      this.isAdmin = identity.isAdmin();
      this.showMenu = true;
    }
  }

  public emitCloseSideMenu() {
    this.closeSideMenu.emit();
  }

  public signOut() {
    this.identityService.signOut('user-initiated-mega-menu');
  }

  public setUserBackOffice(): void {
    this.accountAdminService.userBackOfficeBS.next(true);
  }

  public openBugReport(event?: Event) {
    if (event) {
      event.preventDefault();
    }
    const urlTree = this.router.parseUrl('/backoffice/bugreports');
    window.history.replaceState(null, '', this.router.serializeUrl(urlTree));

    // Update the URL without triggering a navigation
    window.history.replaceState({}, '', '/backoffice/bugreports');

    // Open the component as a dialog
    this.dialog.open(BugreportComponent, {
      width: '600px',
      disableClose: true,
    });
  }

  public openAdminSettingsModal(): void {
    this.settingsService.triggerOpenAdminSettingsModal();
  }

  ngOnDestroy(): void {
    if (this.contextSubscription) {
      this.contextSubscription.unsubscribe();
    }
  }
}
